const getValue = (obj, path) => {
  const splittedPath = path.split('.');
  for (let i = 0; i < splittedPath.length; i += 1) {
    // eslint-disable-next-line no-param-reassign
    obj = obj[splittedPath[i]];
    if (!obj || obj === -1) {
      return undefined;
    }
  }
  return obj;
};

/**
 * This function walk the prePopulation Object in stringify format
 * and return all the evaluator expression.
 */
const getEvaluators = (prePopulation) => {
  const currentEvaluators = []; // List of evaluator expression like @@pageContext.SomeProp@@

  const simpleEvaluatorRegex = /(@@|%%)([a-zA-Z.0-9_]+)(@@|%%)/g; // Regular expression to match everymundo expression
  const complexEvaluatorRegex = /\$\$(\w+)\(([a-zA-Z.0-9_]+)([ ]*,[ ]*'?(.*?)'?)?\)\$\$/g; // Regular expression to match everymundo expression

  let match;
  while ((match = simpleEvaluatorRegex.exec(prePopulation)) !== null) {
    // Get expression inside @@ delimiters
    currentEvaluators.push(match[2]);
  }
  while ((match = complexEvaluatorRegex.exec(prePopulation)) !== null) {
    currentEvaluators.push({
      template: complexEvaluatorRegex,
      type: match[1],
      value: match[2],
      defaultValue: match[3]
    });
  }

  return currentEvaluators;
};

export const evaluateObject = (myOriginalObject, valuesMapObject) => {
  if (myOriginalObject && valuesMapObject) {
    let tempObject = JSON.stringify(myOriginalObject);
    const currentEvaluators = getEvaluators(tempObject);

    const values = new Map();

    for (let i = 0; i < currentEvaluators.length; i += 1) {
      const evaluator = currentEvaluators[i].type
        ? currentEvaluators[i].value
        : currentEvaluators[i];
      const type = currentEvaluators[i].type;
      const currentEvaluatorRootObject = evaluator.split('.')[0];
      let value = getValue(valuesMapObject, evaluator);
      if (currentEvaluatorRootObject === 'window') {
        if (typeof window !== 'undefined') {
          value = getValue(window, evaluator);
        }
      }

      if (type) {
        values.set(evaluator, { value, type });
      }
      if (value) {
        if (typeof value === 'object') {
          // Prevent Array Object ["Value1", "Value2" ... "Valuen"] to coerce to String "Value1, Value2 ... Valuen"
          value = JSON.stringify(value);
          tempObject = tempObject.replace(
            new RegExp(`\\"(@@|%%)${evaluator}(@@|%%)\\"`, 'g'),
            value
          );
        } else {
          tempObject = tempObject.replace(new RegExp(`(@@|%%)${evaluator}(@@|%%)`, 'g'), value);
        }
      } else {
        tempObject = tempObject.replace(new RegExp(`\\"(@@|%%)${evaluator}(@@|%%)\\"`, 'g'), null);
      }
    }

    tempObject = tempObject.replace(
      /"\$\$(\w+)\(([a-zA-Z.0-9_]+)([ ]*,[ ]*'?(.*?)'?)?\)\$\$"/g,
      (match, p1, evaluator, separator, defaultValue) => {
        const matchedValue = values.get(evaluator);
        const value = matchedValue?.value ?? defaultValue;
        const type = matchedValue?.type;
        if (type === 'String' && value === 'null') {
          return null;
        }
        if (type === 'Number') {
          return value ?? `null`;
        } else if (type === 'Object') {
          if (typeof value === 'object') {
            return JSON.stringify(value);
          } else {
            return value != null ? value.replace(/\\"/g, '"') : `null`;
          }
        } else {
          if (type === 'Boolean') {
            return value.toString() === 'true';
          } else {
            return value != null ? `"${value}"` : `null`;
          }
        }
      }
    );

    try {
      return JSON.parse(tempObject);
    } catch (err) {
      console.error(err);
      // if don't possible evaluated the prePopulation log the error and
      // return the origin prePopulation
      return myOriginalObject;
    }
  } else {
    return myOriginalObject;
  }
};
